import djangoIcon from '../../assets/images/skills/django.svg';
import rubyIcon from '../../assets/images/skills/ruby.svg';
import solidityIcon from '../../assets/images/skills/solidity.png';

import flutterIcon from '../../assets/images/skills/flutter.png'
import { 
	faNode,
	faPython,
	faLaravel,
	faReact,
	faVuejs,
	faJs,
	faAngular,
	faHtml5,
	faCss3,
	faPhp,
	faEthereum,
	faRust,
	faAmazon,
	faGolang,
	faShopify,
	faDocker,
	faJava,
	faSwift
 } from "@fortawesome/free-brands-svg-icons"
export const skillCat = {
	web: {
		categoryName: 'Web Dev',
		percentage: 70,
		skillList: [
			{ name: 'Python', xp: '8 YRS', icon: faPython },
			{ name: 'Django', xp: '6 YRS', icon: djangoIcon },
			{ name: 'Node', xp: '8 YRS', icon: faNode },
			{ name: 'HTML5', xp: '7 YRS', icon: faHtml5 },
			{ name: 'PHP', xp: '7 YRS', icon: faPhp },
			{ name: 'Laravel', xp: '5 YRS', icon: faLaravel },
			{ name: 'Ruby on Rails', xp: '4 YRS', icon: rubyIcon },
			{ name: 'JavaScript', xp: '10 YRS', icon: faJs },
			{ name: 'React', xp: '8 YRS', icon: faReact },
			{ name: 'Vue', xp: '6 YRS', icon: faVuejs },
			{ name: 'Anguar', xp: '8 YRS', icon: faAngular },
			{ name: 'HTML', xp: '10 YRS', icon: faHtml5 },
			{ name: 'CSS', xp: '10 YRS', icon: faCss3 },
			{ name: 'Shopify', xp: '4 YRS', icon: faShopify },
			{ name: 'AWS', xp: '7 YRS', icon: faAmazon },
			{ name: 'Docker', xp: '7 YRS', icon: faDocker },
		],
	},
	game: {
		categoryName: 'Blockchain Dev',
		percentage: 10,
		skillList: [
			{ name: 'Ether.js', xp: '3 YRS', icon: faEthereum },
			{ name: 'Solidity', xp: '5 YRS', icon: solidityIcon },
			{ name: 'Rust', xp: '1 YR', icon: faRust },
			{ name: 'Golang', xp: '2 YRS', icon: faGolang },
		],
	},
	mobile: {
		categoryName: 'Mobile App',
		percentage: 20,
		skillList: [
			{ name: 'React Native', xp: '9 YRS', icon: faReact },
			{ name: 'Java', xp: '7 YRS', icon: faJava },
			{ name: 'faSwift', xp: '7 YRS', icon: faSwift },
			{ name: 'flutter', xp: '4 YRS', icon: flutterIcon },
		],
	},
	soft: {
		categoryName: ['Creative', 'Perseverant', 'Patient', 'Enthusiastic', 'Hardworking', 'Amusing'],
		percentage: 100,
	},
};
